import  { useState } from 'react';
import { Table, Tag, Button, Space, Tooltip } from 'antd';
import { EyeOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
const NovedadesTable = ({ novedades, onEditar, onEliminar, onVisualizar, canEdit, canDelete, canView  }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10; 
  const hasActions = canView || canEdit || canDelete;

  const tiposNovedadMap = {
    1: 'Fallecimiento',
    2: 'Retiro Voluntario',
    3: 'Exclusión',
    4: 'Corrección o actualización de información',
    5: 'Otra',
  };

 const columns = [
  {
    title: '#',
    key: 'index',
    render: (_text, _record, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: 'Participante',
    dataIndex: 'nombre_participante',
    key: 'nombre_participante',
  },
  {
    title: 'Cédula',
    dataIndex: 'numero_identificacion',
    key: 'numero_identificacion',
  },{
    title: 'Proyecto',
    dataIndex: 'nombre_proyecto',
    key: 'nombre_proyecto',
  },
  {
    title: 'Departamento',
    dataIndex: 'departamento',
    key: 'departamento',
  },
  {
    title: 'Municipio',
    dataIndex: 'municipio',
    key: 'municipio',
  },
  {
    title: 'Criterios',
    dataIndex: 'tipo_novedad',
    align: 'center',
    key: 'tipo_novedad',
    render: (tipo) => (
      <Tag color="blue">{tiposNovedadMap[tipo] || 'Desconocido'}</Tag>
    ),
  },
  {
    title: 'Soportes',
    key: 'total_soportes',
    render: (_, record) => (
      <Tag color="purple">{(record.soportes?.length + record.soportesRemplazo?.length) || 0} archivo(s)</Tag>
    ),
  },
  {
    title: 'Estado',
    dataIndex: 'estado',
    key: 'estado',
    render: (estado) => {
      const color = estado === 1 ? 'green' : 'red';
      const texto = estado === 1 ? 'Activo' : 'Inactivo';
      return <Tag color={color}>{texto}</Tag>;
    },
  },
  {
    title: 'Reemplazo',
    key: 'reemplazo',
    width: '10%',
    align: 'center',
    render: (_, record) => (
      record.estado_remplazo === 1 ? (
        <Tag color="green">Sí ({record.nombre_reemplazo || record.identificacion_reemplazo})</Tag>
      ) : (
        <Tag color="default">No</Tag>
      )
    ),
  },
  {
    title: 'Fecha de Registro',
    dataIndex: 'fecha_registro',
    key: 'fecha_registro',
    render: (fecha) => dayjs(fecha).format('DD-MM-YYYY'),
  },
  ...(hasActions ? [{
    title: 'Acciones',
    key: 'acciones',
    render: (_, novedad) => (
      <Space size="middle">
        {canView && (
          <Tooltip title="Visualizar">
            <Button icon={<EyeOutlined />} onClick={() => onVisualizar(novedad)} />
          </Tooltip>
        )}
        {canEdit && (
          <Tooltip title="Editar">
            <Button icon={<EditOutlined />} onClick={() => onEditar(novedad)} />
          </Tooltip>
        )}
        {canDelete && (
          <Tooltip title="Eliminar">
            <Button danger icon={<DeleteOutlined />} onClick={() => onEliminar(novedad)} />
          </Tooltip>
        )}
      </Space>
    ),
  }] : []),
];

  return (
    <Table
      rowKey="oid"
      columns={columns}
      dataSource={novedades}
      scroll={{ x: 'max-content' }}
      pagination={{
        pageSize,
        onChange: (page) => setCurrentPage(page),
      }}
      locale={{ emptyText: 'No se encontraron registros' }}
    />
  );
};

export default NovedadesTable;
